import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import strings from '../../locales/';
import StartShiftHistogramGraph from './startShiftHistogramGraph';
import RotationHistogramGraph from './rotationHistogramGraph';
import ShiftLengthHistogramGraph from './shiftLengthHistogramGraph';
import ConsecutiveWorkingDaysHistogramGraph from './consecutiveWorkingDaysHistogramGraph';
import TitleMain from '../titleMain';
const ModalHeader = Modal.Header;
const ModalTitle = Modal.Title;
const ModalBody = Modal.Body;
const FatigueMoreDetailsModal = (props) => (
 <Modal 
  onHide={props.onHide} 
  show={props.show} 
  bsSize="lg" 
  className={"system-modal fatigue-more-details-modal"}
 >
  <div className={'modalContent'}>
    <ModalHeader closeButton>
     <ModalTitle id="contained-modal-title-lg">{strings.fatigue_indicators.labels["detailMainIndicators"]}</ModalTitle>
    </ModalHeader>
    <ModalBody>
    <div className="modal-body-inner">
     <div className="modal-histograms-row">
      <div className="modal-histograms-col">
       <TitleMain title={strings.fatigue_indicators.labels["startShift"]} />
       {
        props.data.startShift && props.data.startShift.length > 0 &&
        <StartShiftHistogramGraph data={props.data.startShift} language={strings}/>
       }
      </div>
      <div className="modal-histograms-col">
       <TitleMain title={strings.fatigue_indicators.labels["rotation"]} />
       {
        props.data.rotation && props.data.rotation.length > 0 &&
        <RotationHistogramGraph data={props.data.rotation} language={strings}/>
       }
      </div>
     </div>
     <div className="modal-histograms-row">
      <div className="modal-histograms-col">
       <TitleMain title={strings.fatigue_indicators.labels["shiftLength"]} />
       {
        props.data.shiftLength && props.data.shiftLength.length > 0 &&
        <ShiftLengthHistogramGraph data={props.data.shiftLength} language={strings}/>
       }
      </div>
      <div className="modal-histograms-col">
       <TitleMain title={strings.fatigue_indicators.labels["consecutiveWorkingDays"]} />
       {
        props.data.workingDays && props.data.workingDays.length > 0 &&
        <ConsecutiveWorkingDaysHistogramGraph data={props.data.workingDays} language={strings}/>
       }
      </div>
     </div>
    </div>
    </ModalBody>
  </div>
 
 </Modal>
);
export default FatigueMoreDetailsModal;



// WEBPACK FOOTER //
// ./source/client/components/common/fatigue/fatigueMoreDetailsModal.jsx